import { Outlet } from "react-router-dom";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import SmoothScroll from "@/components/SmoothScroll";
import Preloader from "@/components/Preloader";
import RouteTransition from "@/components/RouteTransition";
import TrackClosureNotice from "@/components/TrackClosureNotice";

export const Layout = () => {
  return (
    <SmoothScroll>
      <Preloader />
      <RouteTransition />
      <div className="relative bg-[#050505] text-white noise min-h-screen">
        <TrackClosureNotice />
        <Navigation />
        <div>
          <Outlet />
          <Footer />
        </div>
      </div>
    </SmoothScroll>
  );
};

export default Layout;

